module.exports = __webpack_public_path__ + "static/media/adept7-test.25df0abf.pdf";